export enum Step {
  EditSystolicDay = "EditSystolicDay",
  EditDiastolicDay = "EditDiastolicDay",
  EditSystolicNight = "EditSystolicNight",
  EditDiastolicNight = "EditDiastolicNight",
  AllSet = "AllSet",
}
